import React, { FC } from 'react';

import { Grid } from '@chakra-ui/react';

import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

import {
  AccountLocator,
  SnowflakeID,
  Owner,
  Name,
  CreatedAt,
  LastModified,
  Schema,
  SnowflakeDatabase,
  Type,
  ClusteringKey,
  RowCount,
  Bytes,
  RetentionTime,
  RowAccessPolicy,
} from '../../../../Components/MetadataField/MetaGridFields';

export const SnowflakeTableMetadata: FC = () => {
  const { resourceDetails, resourceInsight } = useActiveResourceContext();
  const { data: resource } = resourceDetails;
  const { data: insight } = resourceInsight;

  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={4}>
      {Name(insight)}
      {AccountLocator(insight)}
      {SnowflakeID(insight)}
      {Owner(resource)}
      {SnowflakeDatabase(resource)}
      {Schema(resource)}
      {Type(resource)}
      {ClusteringKey(resource)}
      {RowCount(resource)}
      {Bytes(resource)}
      {RetentionTime(resource)}
      {CreatedAt(resource, 'dayjs')}
      {LastModified(resource)}
      {RowAccessPolicy(resource)}
    </Grid>
  );
};
